
import { Navigation, Swiper } from "swiper";
import {v4 as uuid} from "uuid";

export default {
    props: {
        card: {
            type: Object,
        },
        activeTab: {
            type: Object,
        },
    },
    emits: ['change'],
    methods: {
        onChange(tab) {
            this.$emit('change', tab);
        },
    },
    mounted() {
        this.$nextTick(() => {
            Swiper.use([Navigation]);
            this.navSwiper = new Swiper('.' + this.swiperId, {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                loop: false,
                slidesPerView: "auto",
                spaceBetween: 30,
                mousewheel: true,
                breakpoints: {
                    0: {
                        slidesOffsetBefore: 15,
                        slidesOffsetAfter: 50
                    },
                    768: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    },
                }
            });
        });
    },
    data() {
        return {
            swiperId: 'js-swiper-navigation-' + uuid(),
            navSwiper: null,
        };
    }
}
